var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000.000000pt",
    height: "1000.000000pt",
    viewBox: "0 0 1000.000000 1000.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7175 9994 c-16 -2 -73 -9 -125 -15 -374 -42 -779 -205 -1101 -446 -123 -91 -316 -277 -413 -398 -356 -440 -532 -967 -513 -1535 11 -334 84 -636 223 -930 l55 -114 -2439 -2441 c-2304 -2305 -2441 -2444 -2476 -2512 -102 -200 -102 -439 1 -636 45 -85 160 -206 245 -255 146 -86 337 -114 496 -74 102 26 190 68 262 127 l55 44 370 -369 c431 -429 426 -425 575 -425 147 0 148 1 476 329 259 259 283 286 304 341 33 87 32 181 -4 261 -24 53 -70 103 -401 434 l-375 375 237 237 238 238 375 -375 c421 -420 430 -427 559 -428 81 -1 133 13 192 52 24 17 161 148 305 293 305 308 309 313 309 458 0 150 9 138 -421 570 l-374 375 1218 1218 1218 1218 94 -44 c441 -205 891 -276 1344 -212 771 108 1427 586 1765 1286 322 664 317 1419 -13 2073 -123 243 -263 433 -462 626 -196 190 -372 312 -619 431 -219 105 -430 170 -665 204 -100 15 -452 28 -515 19z m366 -1350 c203 -38 357 -122 514 -279 144 -144 212 -262 267 -463 32 -117 32 -364 0 -482 -109 -401 -415 -680 -817 -745 -322 -53 -641 55 -875 294 -193 198 -289 452 -277 736 6 146 32 255 93 384 57 122 113 198 215 296 139 133 296 217 479 256 109 23 290 24 401 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.2dc8b86fa9de23ef6528c876c07169fa.svg";
export { ForwardRef as ReactComponent };